var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormControl, Button } from 'react-bootstrap';
import { IcIcon } from './../../index';
import { UilPlus, UilMinus } from "@iconscout/react-unicons";

import './InputSpinner.css';

var InputSpinner = function InputSpinner(_ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        min = _ref.min,
        max = _ref.max,
        _ref$btnClassName = _ref.btnClassName,
        btnClassName = _ref$btnClassName === undefined ? "" : _ref$btnClassName,
        variant = _ref.variant,
        rest = _objectWithoutProperties(_ref, ['value', 'onChange', 'min', 'max', 'btnClassName', 'variant']);

    var increment = useCallback(function () {
        if (max) {
            if (value + 1 <= max) {
                onChange(value + 1);
            }
        } else {
            onChange(value + 1);
        }
    }, [value, onChange]);

    var decrement = useCallback(function () {
        if (min) {
            if (value - 1 >= min) {
                onChange(value - 1);
            }
        } else {
            onChange(value - 1);
        }
    }, [value, onChange]);

    var onChangeInput = useCallback(function (e) {
        var newValue = parseInt(e.target.value);
        if (min && newValue < min) {
            return;
        }
        if (max && newValue > max) {
            return;
        }

        onChange(newValue);
    }, [onChange]);

    return React.createElement(
        'div',
        { className: 'd-flex' },
        React.createElement(
            Button,
            { className: 'spinner-buttons ' + btnClassName, variant: variant, onClick: decrement },
            React.createElement(IcIcon, { icon: UilMinus, size: 'sm' })
        ),
        React.createElement(FormControl, _extends({
            type: 'number',
            value: value,
            onChange: onChangeInput,
            min: min,
            max: max
        }, rest)),
        React.createElement(
            Button,
            { className: 'spinner-buttons ' + btnClassName, variant: variant, onClick: increment },
            React.createElement(IcIcon, { icon: UilPlus, size: 'sm' })
        )
    );
};

InputSpinner.defaultProps = {
    variant: "dark"
};
InputSpinner.propTypes = process.env.NODE_ENV !== "production" ? {

    btnClassName: PropTypes.string,
    variant: PropTypes.oneOf(["dark", "light", "primary", "secondary", "warning", "success", "danger", "info", "outline-dark", "outline-light", "outline-primary", "outline-secondary", "outline-warning", "outline-success", "outline-danger", "outline-info"])

} : {};
export default InputSpinner;